import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { PrimeCalendarComponent } from './prime-calendar/prime-calendar.component';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { UnblockBlockDateComponent } from './unblock-date/unblock-date.component';
import { ViewInvoice } from './view-invoice/view-invoice.component';
const routes: Routes = [
  { path: 'calendar', component: PrimeCalendarComponent, canActivate: [AuthGuard] },
  { path: 'viewsummary', component: ViewSummaryComponent, canActivate: [AuthGuard] },
  { path: 'unblockslot', component: UnblockBlockDateComponent, canActivate: [AuthGuard] }
  // ,
  // // { path: 'viewinvoice', component: ViewInvoice, canActivate: [AuthGuard] }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrimecalendarRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/primecalendar/primecalendar-routing.module.ts